$(function(){
    // checkServerAvailableUserActive();
	if(IS_AUTHORISED_PAGE)
	{
		if (window.self == window.top)
		{
		var interval          = setInterval(function(){checkServerAvailableUserActive(interval)}, SERVER_AVAILABLE);
		}
	}

	$('.dropdown-submenu a.submenu-link').on("click", function(e){
		$(this).next('ul').toggleClass('show');
		$(this).toggleClass('submenu-open');
		e.stopPropagation();
		e.preventDefault();
	});

	$('.dropdown').on("hidden.bs.dropdown", function() {
		// hide any open menus when parent closes
		$('.dropdown-menu.show').removeClass('show');
		$('.dropdown-submenu >a').removeClass('submenu-open');
	});

	 // Toggle the side navigation
	$("#sidebarToggle, #sidebarToggleTop").on('click', function(e) {
		$("body").toggleClass("sidebar-toggled");
		$(".sidebar").toggleClass("toggled");
		if ($(".sidebar").hasClass("toggled")) {
		  $('.sidebar .collapse').collapse('hide');
		};
	});

	$("#navbar-toggler").on('click', function(e) {
		$("body").toggleClass("navbar-toggled");
		$(".navbar-collapse").toggleClass("menu-toggled");
	});

	// To aviod the closing of drop-down when clicking inside the drop-down .
	$(document).on('click', '.keep-open.dropdown-menu', function (e) {
		e.stopPropagation();
	    });
    // To avoid closing of filter box when we deselect multi-select option
    $(document).on('click', '.select2-selection__choice__remove', function (e) {
        e.stopPropagation();
    });
	//Close grid filter
	$(document).on('click', '#gridFilterClose', function (e) {
		$('.gridfilter-tab').dropdown("toggle");
    });


	// Close any open menu accordions when window is resized below 768px
	$(window).resize(function() {
	if ($(window).width() < 768) {
	  $('.sidebar .collapse').collapse('hide');
	};
	if ($(window).width() > 768 &&  $("body").hasClass("navbar-toggled")) {
		$("body").removeClass("navbar-toggled");
	}
	// Toggle the side navigation when window is resized below 480px
	if ($(window).width() < 480 && !$(".sidebar").hasClass("toggled")) {
			$("body").addClass("sidebar-toggled");
			$(".sidebar").addClass("toggled");
			$('.sidebar .collapse').collapse('hide');
		};
	});

	$('[data-bs-toggle="tooltip"]').tooltip()


	$(".popover-link").popover({
		container: 'body',
		html : true,
		sanitize: false
	})



	setTimeout(function() {
		$(".alert-auto-close").each(function() {
			$(this).find(".alert").alert('close')
		})
	}, 20000);

	$('.numOnly').numeric();

	$('.summernote-lite').each(function(){
		$($(this)).summernote({
			height: $(this).data('height') ? $(this).data('height') : 150,
			toolbar: [
				['style', ['style']],
				['font', ['bold', 'underline', 'clear']],
				['fontname',['fontname']],
				['color', ['color']],
				['para', ['ul', 'ol', 'paragraph']],
				['view', ['fullscreen', 'codeview', 'help']]
			  ]
		});
	});
	$('.note-toolbar .note-btn.btn.dropdown-toggle').removeAttr('data-toggle').attr('data-bs-toggle','dropdown')


	$('.max-chars-note').maxlength({
		showOnReady:true,
		appendToParent:true,
		warningClass:'form-label-success text-danger',
		limitReachedClass:'form-label-danger text-danger',
		message: "You have %charsRemaining% characters left",
		placement: 'position',
		validate: true
	});


	$(document).on('click', ".popup-window-link", function(e){
		e.preventDefault();
		var popupsection        = $(this).data('popupsection');
		var popupsize     	    = $(this).data('popupsize');
		var addonmodalclass     = $(this).data('addonmodalclass');
		var popupvalignmiddle   = $(this).data('popupvalignmiddle');
		var backdropProp  		= $(this).data('backdrop');
		var oncloseaction  		= $(this).data('oncloseaction');
		var onclosereload		= $(this).data('onclosereload');
		var showProgressMessage = $(this).data('showprogressmessage');

        if(typeof showProgressMessage === 'undefined' || showProgressMessage=="")
		{
			var showProgressMessage = false;
		}
		var backdrop ='' ;
		if(typeof backdropProp !== 'undefined' && (backdropProp=='true' || backdropProp=='false' || backdropProp=='static'))
		{
			backdrop = backdropProp;
		}
		var model_class ='';
		if(typeof popupsize !== 'undefined' && (popupsize=='sm' || popupsize=='lg' || popupsize=='xl'))
		{
			model_class = 'modal-'+popupsize;
		}
		if(typeof popupvalignmiddle !== 'undefined' && popupvalignmiddle==true)
		{
			model_class+=' modal-dialog-centered';
		}
		if(typeof addonmodalclass !== 'undefined')
		{
			model_class+=' '+addonmodalclass;
		}


        var allowIframeScroll   = $(this).data('allowiframescroll');
        if((typeof allowIframeScroll === 'undefined') || (allowIframeScroll=="") || (allowIframeScroll=='yes'))
		{
			var allowIframeScroll = '';
		}else
        {
            var allowIframeScroll = 'scrolling="no"';
		}

		if (typeof popupsection != 'undefined'){
			var popupWindow = popupsection+'Window';
			var href        = $(this).attr('href');
		}else
		{
			alert('required attribute not defined');
			return;
		}
		if($('#'+popupWindow).length >0){$('#'+popupWindow).remove();}

		var windowHtml  = '<div class="modal fade" id="'+popupWindow+'" data-bs-backdrop="'+backdrop+'"  tabindex="-1" role="dialog"  aria-hidden="true">'+
								'<div class="modal-dialog '+model_class+'" role="document">'+
									'<div class="modal-content"><div class="pr-2"><button type="button" class="btn-close-button topright" data-bs-dismiss="modal" aria-label="Close">'+
									'<span aria-hidden="true">&times;</span></button></div>	';

		if(showProgressMessage==true)
		{
			var windowHtml = windowHtml+'<div class="popupLoadingMessage"><i class="fa fa-spinner fa-spin"></i> Please bear with us while we retrieve the details to serve your request.</div>';

		}

		var windowHtml = windowHtml+'<iframe id="iframeWindow" src="'+href+'" '+allowIframeScroll+' frameBorder="0" class="w-100" ></iframe></div></div></div>';

		$('body').append(windowHtml);

		$( "#"+popupWindow+" #iframeWindow" ).on( "load", function() {
			$('.popupLoadingMessage').remove();
		});
		//var modal = new bootstrap.Modal('#'+popupWindow);
		//$('#'+popupWindow).modal({'backdrop':backdrop});
                $('#'+popupWindow).modal('show');
		if(typeof oncloseaction !== 'undefined' && oncloseaction == 'reload')
		{
			$('#'+popupWindow).on('hidden.bs.modal', function (e) {
				if(onclosereload==true)
				{
					window.location.reload();
				}else
				{
					window.location.href=window.location.href;
				}
			})
		}
	});


	$(document).on('click', ".offcanvas-window-link", function(e){
		e.preventDefault();
		var section       		= $(this).data('offcanvassection');
		var position	        = $(this).data('offcanvasposition');
		var oncloseaction  		= $(this).data('oncloseaction');
		var showProgressMessage = $(this).data('showprogressmessage');
		var allowIframeScroll   = $(this).data('allowiframescroll');

        if(typeof showProgressMessage === 'undefined' || showProgressMessage=="")
		{
			showProgressMessage = false;
		}
		if((typeof allowIframeScroll === 'undefined') || (allowIframeScroll=="") || (allowIframeScroll=='yes'))
		{
			allowIframeScroll = '';
		}else
        {
            allowIframeScroll = 'scrolling="no"';
		}

		if (typeof section != 'undefined'){
			var offcanvasWindow = section+'Window';
			var href        = $(this).attr('href');
		}else
		{
			alert('required attribute not defined');
			return;
		}
		if($('#'+offcanvasWindow).length >0){$('#'+offcanvasWindow).remove();}

		var windowHtml  = '<div class="offcanvas '+position+'" tabindex="-1" id="'+offcanvasWindow+'">'+
			'<div class="offcanvas-close-button"><button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button></div>';

		if(showProgressMessage==true)
		{
			 windowHtml = windowHtml+'<div class="offcanvasLoadingMessage"></div>';

		}

		windowHtml = windowHtml+'<iframe id="ofCanvasIframeWindow" src="'+href+'" '+allowIframeScroll+' frameBorder="0" class="w-100 d-none" ></iframe></div>';

		$('body').append(windowHtml);
		$("#"+offcanvasWindow).offcanvas('show');
		$( "#"+offcanvasWindow+" #ofCanvasIframeWindow" ).on( "load", function() {
			$('.offcanvasLoadingMessage').remove();
			$("#ofCanvasIframeWindow").removeClass("d-none");
		});

		if(typeof oncloseaction !== 'undefined' && oncloseaction == 'reload')
		{
			$('#'+offcanvasWindow).on('hidden.bs.offcanvas', function (e) {
				window.location.reload();
			})
		}

	});
	$(".offcanvas-submit-form").on('submit',function(){
		var  windowHtml = '<div class="offcanvasLoadingMessage"></div>';
		$('body').append(windowHtml);
	})
	if($(".offcanvasSuccessMessageBgWindow").length >0) {
		setTimeout(function(){
			$(".offcanvasSuccessMessage").slideUp();
			$(".offcanvasSuccessMessageBgWindow").show(200)
		}, 2000);
	}

	$(".btn-process-default").on('click',function(){
		showBtnProcess($(this));
		return true;

	})
	$("#loginForm, #registrationForm").submit(function(){
		if(checkCookieConsent())
		{
			showBtnProcess($(this).find('.btn-process'));
			return true;
		}
		return false;
    })
    $(".cookie-consent-required").on('click', function (e){

        if(!checkCookieConsent())
        {
            e.preventDefault();
        }
    });

	$('.select2').each(function () {

		$(this).select2({
			theme: 'bootstrap4',
			width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
			placeholder: $(this).data('placeholder'),
			allowClear: Boolean($(this).data('allow-clear')),
			minimumResultsForSearch:  $(this).data('minimum-results-for-search') ? $(this).data('minimum-results-for-search') : 0,
		});
	});
    $('.select2-search__field').css('width', '100%');

	/* Notification Starts */
	$("#notification-wrapper").on("show.bs.dropdown", function(){
		if($("#notification-container").is(':empty'))
		{
			$.ajax({
				url: BASE_URL+"core/notification/getusernotification",
				method: "GET",
				async: false,
				dataType: "JSON",
				success:function(jsonResult){
					if(jsonResult.hasOwnProperty('html'))
					{
						$("#notification-container").html(jsonResult.html);
					}
				}
			});
		}
	});

	$(document).on('click','.notification-list .notification-clear-link',function(){
		var thisObj  = $(this);
		$.ajax({
			url: BASE_URL+"core/notification/clearnotification",
			method: "POST",
			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
			data:{id:thisObj.data('id')},
			dataType: "JSON",
			success:function(jsonResult){
				if(jsonResult.hasOwnProperty('status') && jsonResult.status !=false)
				{

					thisObj.closest("li").hide(400, function(){thisObj.closest("li").remove();});
					$("#notification-wrapper .badge-counter").text(jsonResult.count);
					if(jsonResult.count == 0)
					{
						$("#notification-container").html('<div class="text-center">You have no notifications</div>');
					}
				}
			}
		});
	});

	$(document).on('click','.notification-clear-all',function(){
		$.ajax({
			url: BASE_URL+"core/notification/clearnotification",
			method: "POST",
			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
			data:{id:'all'},
			dataType: "JSON",
			success:function(jsonResult){
				if(jsonResult.hasOwnProperty('status') && jsonResult.status !=false)
				{
					$(".notification-list").hide(500, function(){$(".notification-list").remove();});
					$("#notification-wrapper .badge-counter").text(jsonResult.count);
					$("#notification-container").html('<div class="text-center">You have no notifications</div>');
				}
			}
		});
	});

	window.customerNameSearch = function (fieldId,isActive="")
	{
		var $field = $('#'+fieldId);
		$field.select2({
			placeholder: 'Start typing the Customer Name to begin the search',
			minimumInputLength: 1,
			theme: 'bootstrap4',
			ajax: {
				url: BASE_URL+'core/ajax/customernamesearch',
				type: 'POST',
				headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
				dataType: 'json',
				delay: 250,
				data: function (data) {
					return {
						customerName: data.term,
						isActive: isActive,
						source: $field.data('source') || ''
					};
				},
				beforeSend: function(){
					$(".masterCustomerAjaxProgress").show();
				},
				processResults: function (response) {
					$(".masterCustomerAjaxProgress").hide();
					return {
						results: response
					};
				},
				cache: true
			}
		});
	}
	/* Notification ends */

	window.downloadAndRefreshScreen = function (url)
	{
		location.href = url;
		setInterval(function(){
			if($.cookie("myConnectIsFileDownloaded") == 'true')
			{
				$.removeCookie('myConnectIsFileDownloaded',{ path: '/' });
				location.reload();
			}
		}, 2000);
	};

	window.showBtnProcess  = function(btn){
		btn.addClass('btn-processing').removeClass('btn-process');
		return true;
	}

	window.showToast  = function(message){
		$(document).find(".myctoast").remove();
		var html  = '<div class="position-fixed bottom-0 end-0 p-3 myctoast" style="z-index: 11">'+
						'<div id="toast" class="toast hide" role="alert" aria-live="assertive" aria-atomic="true">'+
							'<div class="toast-body">'+message+
							'</div>'+
						'</div>'+
					'</div>';
		$('body').append(html);
		$('#toast').toast('show');
	}

	window.copyToClipboard  = function(value,isShowToast=true){
			var $temp = $("<input>");
		$("body").append($temp);
		$temp.val(value).trigger('select');
		document.execCommand("copy");
		$temp.remove();
		if(isShowToast) {
			showToast("Copied To Clipboard");
		}
	}

	window.sortJsonArrayByKey  = function(array, key,  order = 'asc'){
		return array.sort(function(a, b) {
			var x = a[key];
			var y = b[key];
			if (typeof x === "string") {
				x = x.toLowerCase();
				y = y.toLowerCase();
			}
			if (order === 'asc') {
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			} else if (order === 'desc') {
				return ((x > y) ? -1 : ((x < y) ? 1 : 0));
			}
		});
	}
})

function checkCookieConsent()
{
    var val = $.cookie('cookieconsent_status');
    if(val=='dismiss')
    {
        return true;
    }else
    {
        alert('Please accept the cookie consent to proceed.');
        return false;
    }
}


function openPopUpDialog(popupSection)
{
	var isSaveMode;
	var savedFilterId		= $('#filterHiddenParams #savedFilterKey').val();


    if (typeof popupSection != 'undefined'){
        var popupWindow = popupSection+'Window';
        var popupContent = popupSection+'Content';
    }else
    {
        alert('required attribute not defined');
        return;
    }
    if($('#'+popupWindow).length >0){$('#'+popupWindow).remove();}


    var model_class ='';
    model_class = 'modal-md';

    var backdrop = true;
    var backdrop = 'static';

    var windowHtml  = '<div class="modal fade" id="'+popupWindow+'" tabindex="-1" role="dialog" data-bs-backdrop="'+backdrop+'"   aria-hidden="true">'+
								'<div class="modal-dialog '+model_class+'" role="document">'+
										'<div class="modal-content"><div id="'+popupContent+'" class="container-fluid">\
											<div class="col-md-12 mt-4 mycmodal-header">\
													<h4 class="text-center mb-0">Save Filter</h4>\
											</div>\
											<div class="errorBoxWrapper" style="display:none">\
											<div class="col-md-12 alert notice-alert notice-alert-danger mt-3 shadow d-flex flex-row justify-content-center" >\
												<div class="v-100 d-flex flex-row  icon">\
													<div class="align-self-center">\
														<i class="mdi mdi-close-circle"></i>\
													</div>\
												</div>\
												<div class="w-100 message p-3"><div class="notice-alert-list">\
															<p>The Following Error(s) Occurred:</p>\
															<ul id="validationErrorDetails"></ul>\
												</div></div>\
											</div>\
											</div>\
										<fieldset class="form-fieldset">\
											<legend>Save Filter Data</legend>\
											<div class="row">\
												<div class="col-md-8 ">\
													<div class="mb-3">\
													<label class="form-label required">Name:</label>\
													<input type="text" id="saveFilterName" name="saveFilterName" value=""  class="form-control form-control-sm" autocomplete="off"  maxlength="64"/>\
													</div>\
												</div>\
												<div class="col-md-4 ">\
													<div class="mb-3">\
													<label class="form-label">Default:</label>\
														<label><input type="radio" name="isDefault" class="isDefaultFilter" id="isDefault-1" value="1"> Yes</label> | \
														<label><input type="radio" name="isDefault" class="isDefaultFilter" id="isDefault-0" value="0" checked="true"> No</label> \
													</div>\
												</div>\
											</div>\
										</fieldset>';
										// Check if the filter is editing
										if(savedFilterId != '')
										{
											windowHtml	+= '<fieldset class="form-fieldset">\
																<legend>Save Mode:</legend>\
																<div class="row">\
																	<div class="col-md-8 ">\
																		<div class="mb-3">\
																		<label><input type="radio" name="saveMode" class="filterSaveMode" id="saveMode-overWrite" value="overWrite" checked="true"> Overwrite Existing Filter</label> | \
																		<label><input type="radio" name="saveMode" class="filterSaveMode" id="saveMode-newFilter" value="newFilter"> Create New Filter</label>\
																		</div>\
																	</div>\
																</div>\
															</fieldset>';
										}
								windowHtml+='<fieldset class="noBorder">\
											<div class="row">\
												<div class="text-center col-md-12 noBorder" style="padding: 10px 15px 30px;">\
													<input type="button" name="saveFilterData" id="saveFilterDataSubmit" value="Save Filter" class="btn-submit btn-sm btn btn-process btn-process-default">&nbsp; \
													<input type="button" name="cancelSaveFilterData" id="cancelSaveFilterData" value="Cancel" class="btn-submit btn-sm btn">\
													</div>\
											</div>\
										</fieldset>\
									</div>\
									<div class="pr-2"><button type="button" class="btn-close-button topright" data-disable="close" id="saveUserFilterClose" aria-label="Close">\
									<span aria-hidden="true">&times;</span></button></div></div></div></div>';
    $('body').append(windowHtml);

	if(savedFilterId != '')
	{
		var filterName 		= $('#filterName').val();
		var isDefaultFilter 	= $('#isDefaultFilter').val();
		$('#'+popupWindow+' #saveFilterName').val(filterName);
		$('.isDefaultFilter').attr('checked', false);
		$('#'+popupWindow+' input.isDefaultFilter:radio[value='+isDefaultFilter+']').attr('checked', true);

		// Edit form click functions
		$(".filterSaveMode").on("click", function(e){
			if($(this).val() == 'overWrite')
			{
				$('#'+popupWindow+' #saveFilterName').val(filterName);
				$('#'+popupWindow+' input.isDefaultFilter:radio[value='+isDefaultFilter+']').attr('checked', true);
			} else
			{
				$('#'+popupWindow+' #saveFilterName').val('');
				$('#'+popupWindow+' input#isDefault-0').attr('checked', true);
			}
		});
	}

    $('#'+popupWindow).modal('show');

}

$(document).on('click', "#saveUserFilterClose, #cancelSaveFilterData", function (e){
	$('#saveUserFilterDataWindow').modal('hide');
});

//FOR SAVE AND SHARE FILTER:
$(document).ready(function(){
    // Popup for save user filter
	$(".saveUserFilter").on("click", function(e){
        e.preventDefault();
		var popupsection        	= $(this).attr('popupsection');
		openPopUpDialog(popupsection);

    });

	$(document).on('click', "#saveFilterDataSubmit", function (e){

		var saveFilterName;
		var isDefaultFilter;
		var saveFilterMode;
		var isSaveMode;
		var savedFilterId		= $('#filterHiddenParams #savedFilterKey').val();
		var moduleId					= $('#filterHiddenParams #moduleId').val();
		var currentUserId			= $('#filterHiddenParams #currentUserId').val();

		saveFilterName		= $('#saveFilterName').val();
		isDefaultFilter		= $('input:radio[name=isDefault]:checked').val();

		if ($( ".filterSaveMode" ).length) {
			isSaveMode		= $('input:radio[name=saveMode]:checked').val();
		} else{
			isSaveMode	= '';
		}
		// Validate data
		var errorMessageHtml	= '';
		var postParams 			= 'moduleId='+moduleId+'&userId='+currentUserId+'&filterName='+saveFilterName+'&savedFilterKey='+savedFilterId+'&saveMode='+isSaveMode;
		$.ajax({
			url: BASE_URL+'core/ajax/validateuserfilterdata',
			data: postParams ,
			success: function(result){
				if(result!="")
				{
					if(result.result == 'fail')
					{
						$.each( result.errorMessage, function( key, value ) {
							errorMessageHtml += '<li>'+value+'</li>';
						});
						$('.errorBoxWrapper').show();
						$('#validationErrorDetails').html(errorMessageHtml);
					} else
					{
						$('#filterName').val(saveFilterName);
						$('#isDefaultFilter').val(isDefaultFilter);
						$('#isSaveFilter').val('1');
						if(savedFilterId != '')
						{
							saveFilterMode		= $('.filterSaveMode:checked').val();
							$('#isSaveMode').val(saveFilterMode);
						}
						$('.gridFilter #filterSubmit').click();
					}
				}else
				{
					alert('Unable to validate data at the moment. Please try again later.');
				}
			},
			async:false
		});
	});

});


function openPopUpWindow(popupSection)
{
    if (typeof popupSection != 'undefined'){
        var popupWindow = popupSection+'Window';
        var popupContent = popupSection+'Content';
    }else
    {
        alert('required attribute not defined');
        return;
    }
    if($('#'+popupWindow).length >0){$('#'+popupWindow).remove();}

    var model_class ='';
    model_class = 'modal-md';

    var backdrop = true;
    var backdrop = 'static';

    var windowHtml  = '<div class="modal fade" id="'+popupWindow+'" tabindex="-1" role="dialog" data-bs-backdrop="'+backdrop+'" aria-hidden="true">'+
								'<div class="modal-dialog '+model_class+'" role="document">'+
									'<div class="modal-content"><div id="'+popupContent+'" class="container-fluid"><div class="popupLoadingMessage">&nbsp;<i class="mdi mdi-spin mdi-loading"></i> Please bear with us while we retrieve the details to serve your request.</div></div><div class="pr-2"></div></div></div></div>';
/* <button type="button" class="btn-close-button topright" data-bs-dismiss="modal" aria-label="Close">'+
									'<span aria-hidden="true">&times;</span></button> */
    $('body').append(windowHtml);

    $('#'+popupWindow).modal('show');

}

function checkServerAvailableUserActive(interval)
{
	var userSesssionExists = true;
	var response = isServerAvailable(true, interval);

	if(userSesssionExists == false)
    {
        clearInterval(interval);
		openPopUpWindow('sessionExpiredScreen');
		$(".popupLoadingMessage").hide();
		$("#sessionExpiredScreenContent").html(userSessionExpMsg);
        return;
    }
}

function isServerAvailable(checkUserSession, interval) {
	if(typeof checkUserSession == 'undefined')
	{
		checkUserSession = false;
	}

    var response = {'serverAvaiable': false, 'userSessionActive': false};
    $.ajax({
		url: BASE_URL+'core/ajax/isserveravailable',
		success: function(result){
            $("#serverAvailabilityAlertRibbon").hide();
            response.serverAvaiable = true;
            if(checkUserSession == true)
            {
                $.ajax({
					url: BASE_URL+'core/ajax/checklogin',
					method: "GET",
                    datatype: 'html',
                    success: function(data){
                        if($.trim(data) != "")
                        {
                            response.userSessionActive      = false;
                            response.inactiveSessionMsg     = data;
							if(typeof interval != 'undefined')
							{
                                clearInterval(interval);
                                openPopUpWindow('sessionExpiredScreen');
								$(".popupLoadingMessage").hide();
								$("#sessionExpiredScreenContent").html(data);

							}
                        }else
                        {
                            response.userSessionActive      = true;
                        }
					},
					async: true
                });

            }
		},
		error: function(jqXHR, exception){
            response.serverAvaiable = false;
            $("#serverAvailabilityAlertRibbon").html("<i class='mdi mdi-alert-box'></i>There is a problem connecting to Myconnect server. Please try again later.");
            $("#serverAvailabilityAlertRibbon").show();
        },
		async:true
	});

    return response;
}


